import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { deleteCorporateClient } from "../../Services/CorporateClient.service";

const DeleteConfirmation = ({ Large, title, LargeModaltoggle, deleteId, fetchData }) => {
  const onDeleteSubmit = (formValues) => {
    deleteCorporateClient(deleteId).then(async (result) => {
      showAlert('success', "Corporate Client deleted successfully")
      await fetchData()
      LargeModaltoggle();
    }).catch(err => {
      showAlert('error', err.response?.data?.message
        ? err.response.data.message : 'Something went wrong')
    })
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div className="text-center">Are you sure you want to delete this corporate client ?</div>
        </Col>
        <Col xl="12" className="push-notification-footer">
          <button
            className="btn btn-primary"
            type="submit"
            onClick={() => onDeleteSubmit()}
          >
            Confirm
          </button>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default DeleteConfirmation;
